import {Draggable, gsap, InertiaPlugin} from "gsap/all";
import $ from "jquery";
import Swiper from 'swiper';
import {Navigation} from 'swiper/modules';

Swiper.use([Navigation])

const toolSize = 120;

export class BioScene {

  constructor({selector, toolboxSelector, data, biodiversityCallback, tooltipCallback}) {
    this.$el = $(selector);
    this.data = data;
    this.enabled = false;
    this.$toolbox = $(toolboxSelector);
    this.$draggablesEl = [];
    this.$dropZonesEl = [];

    this.biodiversityCallback = biodiversityCallback;
    this.tooltipCallback = tooltipCallback;

    this.dropzoneHighlight = null;
    this.itemTl = null;
    this.uiTl = null;

    this.init();
  }

  init() {
    this.$draggablesEl = this.$toolbox.find(".draggable");
    this.$dropZonesEl = this.$el.find(".dropzone");

    // Save initial positions
    this.$draggablesEl.each((i, n) => {
      if (!this.enabled) return;
      const currentX = gsap.getProperty(n, "x");
      const currentY = gsap.getProperty(n, "y");
      $(n).data("initial-position", {x: currentX, y: currentY})
    });

    // Make element draggable and bind event listener
    this.createDraggableTools();

    // Create swiper to make tools draggable
    this.createSwiperInstance()

  }

  createDraggableTools() {

    // This is old school `this` scope handling for 'snap' function
    const _this = this;

    this.$draggablesEl.get().forEach((n) => {
      const $el = $(n)
      $el.on("mousedown touchstart", (e) => {
        if ($el.hasClass("is-dragging") === false) {
          $el.addClass("is-dragging");
          _this.createDraggableClone(n, e.originalEvent);
        }
        _this.enableAvailableDropzones($el);
      })
      $el.on("mouseup touchend", (e) => {
        if ($el.hasClass("is-dragging")) {
          _this.disableAllDropzones();
          const toolName = $el.data("tool-name")
          const draggable = Draggable.get($(`.draggable-clone[data-tool-name='${toolName}']`, this.$el))
          draggable.endDrag(e)
        }
      })
    })

    Draggable.zIndex = 5;
  }

  createSwiperInstance() {
    const $swiperEl = this.$el.find('.swiper');
    const level = $swiperEl.parents(".biotoolbox").hasClass("level-3") ? 3 : $swiperEl.parents(".biotoolbox").hasClass("level-2") ? 2 : 1;
    const slidesPerView = (level === 3) ? 9 : (level === 2) ? 10 : 6;
    const hasMultiplePages = (this.$el.find('.swiper .swiper-slide').length > slidesPerView);
    this.swiper = new Swiper($swiperEl.get(0), {
      direction: 'horizontal',
      // slidesPerView: slidesPerView,
      slidesPerView: 'auto',
      slidesPerGroup: slidesPerView,
      threshold: 15,
      allowTouchMove: false,
      navigation: {
        enabled: hasMultiplePages,
        nextEl: hasMultiplePages ? this.$el.find('.swiper-button-next').get(0) : null,
        prevEl: hasMultiplePages ? this.$el.find('.swiper-button-prev').get(0) : null,
      },
    });

    if (!hasMultiplePages) {
      this.$el.find('.swiper-button-next').remove()
      this.$el.find('.swiper-button-prev').remove()
    }

    this.swiper.on('sliderMove', () => {
      if (this.draggable && this.draggable.enabled()) {
        console.log('Slider has moved and we have a draggable, kill currently dragged tool.');
        this.restoreItem(this.draggable)
      }
    });
  }

  createDraggableClone(toolEl, e) {
    Draggable.zIndex = 100;
    const toolName = $(toolEl).data("tool-name")
    const _this = this; // This is old school `this` scope handling for 'snap' function

    app.audio.play("audio/MNS2_Int5.2 Effet domino_SFX/MNS2_ME_INT5.2_SFXpickup.mp3", 1, true);

    $(toolEl).removeClass("enable-transition");
    const rect = toolEl.getBoundingClientRect();
    const strangeOffset = (toolName === "shovel") ? {x: 10, y: 10} : {x: 0, y: 0};
    if ($(toolEl).is(".first-of-group:not(:first-child)")) strangeOffset.x += 20
    const position = {x: rect.x + strangeOffset.x, y: rect.y + strangeOffset.y};

    // Clone DOM
    const $clone = $(toolEl).clone().addClass("draggable draggable-clone");
    gsap.set($clone, {clearProps: "all"});
    gsap.set($clone, {
      width: $("img", toolEl).width(),
      height: $("img", toolEl).height(),
      ...position
    });
    $clone.prependTo(this.$el);

    // Save initial position
    $clone.data("initial-position", position)

    // Start draggable
    const draggables = Draggable.create($clone, {
      inertia: true,
      allowEventDefault: true,
      throwResistance: 10000,
      zIndexBoost: 98,
      maxDuration: 1.0,
      minDuration: 0.05,
      bounds: {top: 20, left: 50, width: 1870, height: 1020},
      onDragStart: (e) => {
        const draggable = Draggable.get(e.target);
        if (draggable) $(draggable.target).data("locked-dropzone", null)
        this.lockSlider();
      },
      onDragEnd: function (e) {
        // Prevent long throw when it has moved less than 150 pixel
        // Under 20 pixel, set back tool position without delay
        const initialPosition = $(this.target).data("initial-position");
        const distance = dist(initialPosition.x, initialPosition.y, this.x, this.y);
        if (distance < 20) {
          this.tween.kill();
          _this.restoreItem(this, toolEl, 0)
          _this.unlockSlider();
          gsap.set(this.target, {...initialPosition}); // No position tween
        } else if (distance < 150) {
          this.tween.kill();
          _this.restoreItem(this, toolEl)
          _this.unlockSlider();
        }
      },
      onDrag: function (e) {
        // If shovel is used, highlight the lockable dropzone
        if (toolName === "shovel") {
          const dropzone = _this.getLockableDropZones({x: this.x, y: this.y}, toolName)
          if (dropzone) _this.highlightDropzone(dropzone)
          else _this.removeHighlightDropzone()
        }
      },
      onThrowComplete: function (e) {
        _this.removeHighlightDropzone()
        Draggable.zIndex = 100;
        const draggable = this;
        const dropZone = $(draggable.target).data("locked-dropzone")
        // console.log("onThrowComplete", dropZone);
        if (dropZone !== null && dropZone !== undefined) {
          if (toolName === "shovel") {
            app.audio.play("audio/MNS2_Int5.2 Effet domino_SFX/MNS2_ME_INT5.2_SFXpelle.mp3", 1, true);
            _this.clearItem(draggable, dropZone, toolEl);
            _this.unlockSlider();
          } else {
            const isNegativeTool = _this.data.tools.find((el) => (el.name === $(toolEl).attr("data-tool-name"))).effect === "negative";
            if (isNegativeTool) app.audio.play("audio/MNS2_Int5.2 Effet domino_SFX/MNS2_ME_INT5.2_SFXdropbad.mp3", 1, true);
            else app.audio.play("audio/MNS2_Int5.2 Effet domino_SFX/MNS2_ME_INT5.2_SFXdropoff.mp3", 1, true);
            _this.lockItem(draggable, dropZone, toolEl);
          }
        } else {
          _this.restoreItem(draggable, toolEl)
        }
      },
      snap: {
        points: function (point) {
          if (!Number.isFinite(point.x) || !Number.isFinite(point.y)) return;
          const draggable = this;
          const dropzone = _this.getLockableDropZones(point, toolName)
          if (dropzone) {
            const dropzonePos = dropzone.getBoundingClientRect()
            $(draggable.target).data("locked-dropzone", dropzone)
            $(draggable.target).addClass("locked");
            return {
              x: dropzonePos.x + (dropzonePos.width / 2) - (toolSize / 2),
              y: dropzonePos.y + (dropzonePos.height / 2) - (toolSize / 2)
            };
          } else {
            return point;
          }
        }
      },
    });

    // Save draggable obejct and start dragging of the clone
    if (draggables.length > 0) {
      this.draggable = draggables[0];
      this.draggable.startDrag(e)
    }
  }

  enableAvailableDropzones(toolEl) {
    const toolName = $(toolEl).data("tool-name");
    const $availableDropZones = this.$dropZonesEl.filter(":not(.complete)");
    for (let i = 0; i < $availableDropZones.length; i++) {
      const dropzone = $availableDropZones[i];
      const dropzoneIndex = $(dropzone).data("dropzone-index")
      const isAvailable = this.isToolAvailableForDropzone(toolName, dropzoneIndex);
      $(dropzone).toggleClass("enabled", isAvailable);
      $(dropzone).toggleClass("disabled", !isAvailable);
    }
  }

  disableAllDropzones() {
    this.$dropZonesEl.filter(":not(.complete)").removeClass("enabled disabled");
  }

  // Used with shovel tool
  highlightDropzone(dropzone) {
    if (this.dropzoneHighlight === dropzone) return
    this.removeHighlightDropzone()
    this.dropzoneHighlight = dropzone;
    gsap.to($(".reveal-item", dropzone), {filter: "brightness(0.8)", duration: 0.3})
  }

  // Used with shovel tool
  removeHighlightDropzone() {
    if (this.dropzoneHighlight) gsap.to($(".reveal-item", this.dropzoneHighlight), {filter: "brightness(1)", opacity: 1, duration: 0.3})
    this.dropzoneHighlight = null;
  }

  isToolAvailableForDropzone(toolName, dropzoneIndex) {
    const dropzoneType = this.data.dropzones[dropzoneIndex - 1].type;
    const dropzoneRestrictions = this.data.restrictions[dropzoneType];
    return (dropzoneRestrictions.includes(toolName));
  }

  getLockableDropZones(point, toolName) {

    // Different available zone logic for shovel and other tools
    let $availableDropZones;
    if (toolName !== "shovel") {
      $availableDropZones = this.$dropZonesEl.filter(":not(.complete)").filter((i, n) => {
        return this.isToolAvailableForDropzone(toolName, $(n).data("dropzone-index"));
      });
    } else {
      $availableDropZones = this.$dropZonesEl.filter(".complete");
    }

    for (let i = 0; i < $availableDropZones.length; i++) {
      const dropzone = $availableDropZones[i];
      const svg = $(dropzone).find("svg").get(0);
      if (svg === null || svg === undefined) continue;
      const svgPosition = $(svg).position();
      const hitRect = svg.createSVGRect();
      hitRect.height = 1;
      hitRect.width = 1;
      hitRect.x = point.x - svgPosition.left + (toolSize / 2);
      hitRect.y = point.y - svgPosition.top + (toolSize / 2);
      const hits = svg.getIntersectionList(hitRect, null);
      if (hits.length > 0) return dropzone
    }
    return null;
  }

  lockItem(draggable, dropZone, toolEl) {
    this.disableAllDropzones();
    const toolName = $(toolEl).data("tool-name")
    const revealedItem = this.getRevealItemForTool(toolName, $(dropZone).data("dropzone-type"));
    $(dropZone).addClass("complete").attr("data-tool-name", toolName);
    $(toolEl).addClass("enable-transition").removeClass("is-dragging");
    const gazon = this.$el.find('.gazon div[data-dropzone-index="' + $(dropZone).data("dropzone-index") + '"]');

    gsap.killTweensOf(gazon);
    this.itemTl = gsap.timeline();

    // Disable, animate out and destroy draggable
    draggable.disable();
    this.itemTl.to(draggable.target, {
      scale: 0,
      duration: 0.35,
      ease: "back.in",
      onComplete: function () {
        draggable.kill()
        draggable = null;
      }
    })

    this.itemTl.add(() => this.triggerDust(dropZone));
    this.itemTl.add(() => $(dropZone).append(revealedItem));
    this.itemTl.add(() => this.unlockSlider());
    this.itemTl.fromTo(revealedItem, {
      scale: 0,
      opacity: 0,
    }, {
      scale: 1,
      opacity: 1,
      duration: 0.5,
      ease: "quad.out"
    })

    // Update biometer
    this.itemTl.add(() => {
      const bioLevel = this.calculateBioDiversity()
      this.biodiversityCallback(bioLevel, toolName, dropZone)
    });

    // Complete comestic animations
    this.itemTl.to($('svg', dropZone), {
      opacity: 0,
      duration: 0.5,
      ease: "sine.inOut"
    }, '<')

    this.itemTl.to(gazon, {
      autoAlpha: 1,
      duration: 2.5,
      ease: "sine.out"
    }, '<')

    this.itemTl.to($('img', gazon), {
      maskSize: '200% 200%',
      duration: 2.5,
      ease: "sine.out"
    }, '<')
  }

  triggerDust(dropZone) {
    const dest = dropZone.getBoundingClientRect();
    const oversize = map(dest.height, 264, 110, 60, 40);
    const offsetY = map(dest.height, 264, 110, -50, 0);
    const finalRect = {
      x: dest.x - oversize,
      y: dest.y - oversize + offsetY,
      width: dest.width + (oversize * 2),
      height: dest.width + (oversize * 2), // animation is squared
    }

    const $dust = $(`#screen-2 .dust`);
    gsap.set($dust, {
      x: finalRect.x,
      y: finalRect.y - ((finalRect.height - dest.height) / 2) + (dest.height * 0.3),
      width: finalRect.width,
      autoAlpha: 1,
    });

    const lottie = $dust.find(`.lottie-animation`).data("lottie");
    lottie.setFrame(0)
    lottie.play()
    lottie.addEventListener("complete", () => {
      lottie.removeEventListener("complete");
      gsap.set($dust, {autoAlpha: 0});
    });

  }

  clearItem(draggable, dropZone, toolEl) {
    this.disableAllDropzones();
    const revealedItem = $(".reveal-item", dropZone);

    // Remove for biolevel memory if it is a positive tool and is not grass
    const isPositiveTool = this.data.tools.find((el) => (el.name === $(dropZone).attr("data-tool-name"))).effect !== "negative" && $(dropZone).attr("data-tool-name") !== "grass";
    if (isPositiveTool) $(dropZone).removeAttr("data-tool-name").removeData("tool-name");

    $(toolEl).addClass("enable-transition").removeClass("is-dragging");
    const gazon = this.$el.find('.gazon div[data-dropzone-index="' + $(dropZone).data("dropzone-index") + '"]');

    gsap.killTweensOf(gazon);
    this.itemTl = gsap.timeline();

    // Disable, animate out and destroy draggable
    draggable.disable();
    this.itemTl.to(draggable.target, {
      scale: 0,
      duration: 0.35,
      ease: "back.in",
      onComplete: function () {
        draggable.kill()
        draggable = null;
      }
    })

    // Swipe out revealed item
    this.itemTl.to(revealedItem, {
      scale: 0,
      opacity: 0,
      duration: 0.5,
      ease: "back.in"
    })

    this.itemTl.to($('svg', dropZone), {
      autoAlpha: 1,
      duration: 0.25,
      ease: "sine.out"
    }, '<')

    this.itemTl.to(gazon, {
      autoAlpha: 0,
      duration: 0.5,
      ease: "sine.out"
    }, '0')

    // Remove complete class from dropzone
    this.itemTl.add(() => $(dropZone).removeClass("complete"));

    // Stop secondary causality
    const dotLottie = $(dropZone).data("secondary-causality");
    if (dotLottie !== null && dotLottie !== undefined) {
      dotLottie.stop();
      gsap.to(dotLottie.canvas, {autoAlpha: 0, duration: 0.2});
      $(dropZone).data("secondary-causality", null);
    }

    // Update biometer
    this.itemTl.add(() => {
      const bioLevel = this.calculateBioDiversity()
      this.biodiversityCallback(bioLevel)
    });

  }

  getPositiveTools() {
    return this.data.tools.reduce((acc, el) => {
      if (el.effect === "positive") acc.push(el.name);
      return acc;
    }, []);
  }

  calculateBioDiversity() {
    // Get values used in the algorithm
    const toolUsage = this.getToolsUsage();
    const dropzoneCount = $(this.$dropZonesEl).length;
    const completedDropzoneCount = $(this.$dropZonesEl).filter(".complete").length;
    const positiveTools = this.getPositiveTools();
    const completeDropzoneWithPositiveToolsCount = Object.keys(toolUsage).reduce((acc, toolName) => {
      if (positiveTools.includes(toolName)) return acc + toolUsage[toolName];
      else return acc;
    }, 0);

    // Define what is a success tool usage, taking in consideration dropzones count, tools count and tools effect.
    const targetToolUsage = {
      min: Math.floor(dropzoneCount / positiveTools.length),
      max: Math.ceil(dropzoneCount / positiveTools.length),
      uniqueTarget: Math.min(positiveTools.length, dropzoneCount),
    }

    const diversityFactor = constrain(Object.entries(toolUsage).reduce((acc, [key, value]) => {
      if (positiveTools.includes(key)) {
        if (value >= targetToolUsage.min) acc++; // is positive and in range
        if (value > targetToolUsage.max) acc -= (value - targetToolUsage.max); // is positive but over range
      } else {
        if (value > 0) acc -= value; // is negative, decrease score
      }
      return acc;
    }, 0) / targetToolUsage.uniqueTarget, 0, 1);

    // Compute score
    // const completedFactor = completedDropzoneCount / dropzoneCount; // Uses all tools for completion count
    const completedFactor = completeDropzoneWithPositiveToolsCount / dropzoneCount; // Uses only positive tools for completion count
    const result = ((diversityFactor + completedFactor) / 2);

    console.log(`Completed Factor (positive tools only): ${completedFactor}\nCompleted: ${completedDropzoneCount / dropzoneCount}\nDiversity & Effect Factor: ${diversityFactor}\nResult: ${result}\n`)

    return {
      completed: completedDropzoneCount / dropzoneCount,
      result: result,
    };
  }

  unlockSlider() {
    if (this.$toolbox.find(".is-dragging").length === 0) {
      this.swiper.enable()
    }
  }

  lockSlider() {
    this.swiper.disable()
  }

  restoreItem(draggable, toolEl = false, duration = 0.5) {
    this.disableAllDropzones();
    const initialPosition = $(draggable.target).data("initial-position");
    draggable.disable();
    gsap.to(draggable.target, {
      x: initialPosition.x,
      y: initialPosition.y,
      duration: (toolEl === false) ? 0 : duration,
      ease: 'sine.out',
      onComplete: () => {
        $(draggable.target).remove();
        draggable.kill();
        draggable = null;
        if (toolEl) $(toolEl).removeClass("is-dragging");
        else this.$toolbox.find(".item").removeClass("is-dragging");
        this.unlockSlider();
      }
    })
  }

  getRevealItemForTool(selectedToolName, dropzoneType) {

    // Get tool object from data
    const toolObject = this.data.tools.find((tool) => {
      return tool.name === selectedToolName;
    })
    if (!toolObject) return null;

    // Get reveal item if it has dropzone constrains
    const reveal = toolObject.reveals.length === 1 ? toolObject.reveals[0] : toolObject.reveals.find((n) => {
      return n.use_for_specific_dropzones.includes(dropzoneType);
    })

    const el = $(`<div class='reveal-item'><img src="${reveal.img}" draggable="false"></div>`);
    gsap.set(el, {
      width: reveal.width,
      x: reveal.x,
      y: reveal.y,
    })
    return el
  }

  getToolsUsage() {
    const startingValue = {}
    this.data.tools.forEach((tool) => {
      startingValue[tool.name] = 0;
    })
    return $(this.$dropZonesEl).get().reduce((acc, el) => {
      const toolName = $(el).attr("data-tool-name");
      if (!toolName) return acc;
      else if (acc[toolName] === undefined) acc[toolName] = 1;
      else acc[toolName]++
      return acc;
    }, startingValue);
  }

  killTimeline(tl) {
    if (tl) {
      tl.kill()
      tl = null;
    }
  }

  enable() {
    this.enabled = true;

    // Animate in timeline
    this.uiTl = this.showUI(1);

    // Show top tooltip synchronously with UI
    this.tooltipCallback(2, 1)
    // this.tooltipCallback(2, this.uiTl.duration() + 1)
  }

  disable() {
    this.enabled = false;
    this.killTimeline(this.itemTl)
    this.disableAllDropzones();
  }

  showUI(delay = 0) {
    const uiTl = gsap.timeline();
    uiTl.add(() => this.$el.find(".biotoolbox").addClass("is-animating"));
    uiTl.fromTo(this.$el.find(".biotoolbox"), {y: 200}, {y: 0, duration: 1, ease: "quad.out"}, delay);
    uiTl.fromTo("#biometer-ui", {x: -300}, {x: 0, duration: 1, ease: "quad.out"}, '<');
    uiTl.add(() => this.$el.find(".biotoolbox").removeClass("is-animating"));
    return uiTl;
  }

  hideUI() {
    const uiTl = gsap.timeline();
    uiTl.add(() => this.$el.find(".biotoolbox").addClass("is-animating"));
    uiTl.to(this.$el.find(".biotoolbox"), {y: 200, duration: 1, ease: "quad.out"}, 0);
    uiTl.to("#biometer-ui", {x: -300, duration: 1, ease: "quad.out"}, '<');
    uiTl.add(() => this.$el.find(".biotoolbox").removeClass("is-animating"));
    return uiTl;
  }

  reset() {

    // Stop timelines
    this.killTimeline(this.itemTl)
    this.killTimeline(this.uiTl)

    // Remove revealed zones
    this.$el.find(".reveal-item").remove();
    this.$dropZonesEl.removeClass("enabled disabled complete").removeAttr("data-tool-name");
    $(this.$dropZonesEl).data("secondary-causality", null);

    // Remove gazon
    gsap.set(this.$el.find('.dropzone svg'), {autoAlpha: 1})
    gsap.set(this.$el.find('.gazon div'), {autoAlpha: 0})
    gsap.set(this.$el.find('.gazon img'), {maskSize: '1% 1%'})

    // Restore tools status
    this.$draggablesEl.removeClass("is-dragging");
    if (this.draggable) {
      this.draggable.kill();
      this.draggable = null;
    }

    // Set slider to 0,0
    this.swiper.slideTo(0, 0)
    this.unlockSlider()

    // Remove draggable clones
    this.$el.find(".draggable-clone").each((i, n) => {
      if (Draggable.get(n)) Draggable.get(n).kill()
      $(n).remove();
    });

    this.removeHighlightDropzone();

  }

}
